import PropTypes from 'prop-types'
import React from 'react'
import WidgetArea from '@/component/Structure/WidgetArea'

const EventSponsorLayoutFooter = ({ section, pageData }) => {
  const eventSponsorLayoutFooterWidget =
    pageData?.eventUmbrella?.event?.sponsor?.footer?.widgets

  return (
    <WidgetArea
      widgets={eventSponsorLayoutFooterWidget}
      section={section}
      pageData={pageData}
      noStack
    />
  )
}

EventSponsorLayoutFooter.propTypes = {
  section: PropTypes.object,
  pageData: PropTypes.object
}

export default EventSponsorLayoutFooter
